import {
  Backdrop, Button, Card, CardActions, CardContent, Checkbox, CircularProgress, Container, Dialog, DialogActions, DialogContent,
  DialogTitle, Divider, FormControl, Grid, TableSortLabel, InputAdornment, LinearProgress, Slide, Snackbar, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, TextField, Typography, Select, createMuiTheme, Paper, TablePagination
} from '@material-ui/core';
import { SearchIcon } from '@material-ui/data-grid';
import MuiAlert from '@material-ui/lab/Alert';
import clsx from 'clsx';
import React, { useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import trLocale from 'date-fns/locale/tr';
import { getUser, sc } from 'src/utils/Common';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import DateFnsUtils from '@date-io/date-fns';
import ExcelExport from 'src/components/ExcelExportScrapReport';
import moment from 'moment';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  cardUstBolum: {
    maxHeight: 800,
    minHeight: 800,
    width: '100%'
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  container: {
    maxHeight: 497,
    minHeight: 497,
    mimWidth: 500
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  rootAdresSearch: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(0)
  },
  selectedRow: {
    backgroundColor: '#ecffde',
    // İlgili diğer stiller
  },
  redText: {
    backgroundColor: '#ffdfd4',
  },
  root1: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(1),
    margin: 'auto',
    maxWidth: '80%',
  },
  header: {
    marginBottom: theme.spacing(1),
  },
  field1: {
    marginBottom: theme.spacing(1),
  },
  table: {
    border: 'none',
    width: '100%'
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});
const localeMap = {
  tr: trLocale
};
const customStyles = {
  overlay: {
    zIndex: 9999, // İstediğiniz z-indeksi burada ayarlayabilirsiniz
  },
  // Diğer stil ayarları burada tanımlanabilir
};


function ScrapReport() {
  const classes = useStyles();
  const today = moment(new Date()).format('YYYY-MM-DD');

  const today1 = new Date();
  let lastWednesday = today1;

  while (lastWednesday.getDay() !== 3) {
    lastWednesday.setDate(lastWednesday.getDate() - 1);
  }


  const [uyari, setUyari] = useState(false);
  const [Loading, setLoading] = useState(false);
  const SessionUser = getUser();
  const [ScrapData, setScrapData] = useState([]);
  const [ScrapDataMain, setScrapDataMain] = useState([]);
  const [ScrapSearch, setScrapSearch] = React.useState("");
  const [TeknisyenKodu, setTeknisyenKodu] = useState(0);
  const [TeknisyenData, setTeknisyenData] = useState([]);
  const [DURUM, setDURUM] = useState(-1);
  const [DurumData, setDurumData] = useState([]);
  const [RowSelectedFull, setRowSelectedFull] = useState(false);
  const [baslangicTarihi, setBaslangicTarihi] = React.useState(moment(lastWednesday).format('YYYY-MM-DD'));
  const [bitisTarihi, setBitisTarihi] = React.useState(moment(lastWednesday).format('YYYY-MM-DD'));
  const [openMaterialFileTitle, setOpenMaterialFileTitle] = React.useState("");
  const [openMaterialFile, setOpenMaterialFile] = React.useState(false);
  const [ImageUrlMuadil, setImageUrlMuadil] = useState(null);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');
  const [uyariTip, setUyariTip] = React.useState('');
  const [uyariAciklama, setUyariAciklama] = React.useState('');
  React.useEffect(() => {
    axios
      .get(`/GetTechnician/${SessionUser.ServiceShopId}`)
      .then(response => {
        if (response.data.length > 0) {
          setTeknisyenData(response.data);
        }
      })
      .catch(error => {
        console.log(error);
      });

    axios
      .get(`/GetScrapStatus`)
      .then(response => {
        if (response.data.length > 0) {
          setDurumData(response.data);
        }
      })
      .catch(error => {
        console.log(error);
      });

  }, []);
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  function onSorgula() {
    setLoading(true);
    setRowSelectedFull(false);
    axios
      .get(
        `/GetScrapData/${SessionUser.ServiceShopId}/${TeknisyenKodu == '' ? 0 : TeknisyenKodu}/${baslangicTarihi}/${bitisTarihi}/${DURUM == '' ? 0 : DURUM}/${-100}`
      )
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setScrapData(response.data);
          setScrapDataMain(response.data);
        } else {
          setScrapData([]);
          setScrapDataMain([]);
        }
      })
      .catch(error => {
        setLoading(false);
        setScrapData([]);
        setScrapDataMain([]);
      });
  }
  const setFilter = (Param) => {
    setScrapSearch(Param);
    setScrapData(ScrapDataMain.filter(item => sc(item.FIS_NO, Param) 
      || sc(item.TEKNISYEN, Param) 
      || sc(item.DURUM, Param)
      || sc(item.MALZEME_STOK_NO, Param)
      || sc(item.MALZEME, Param)
      || sc(item.HURDA_DURUM, Param)
      || sc(item.KRITIK, Param)
      || sc(item.ADET, Param)
      || sc(item.ARAC_TAKIP_NO, Param)
      || sc(item.ISLEM_TARIHI, Param)
      || sc(item.ALINMA_DURUM, Param)
      || sc(item.ESKISI_YOK_ACIKLAMA, Param)
      || sc(item.SURUCU, Param)
      || sc(item.PLAKA, Param)
      || sc(item.ARAC_TESLIM_TARIHI, Param)))

  };

  
  
  
  
  
  

  const search = "";

  const handleteknisyenChange = e => {
    setTeknisyenKodu(e.target.value);
  };
  const handleDurumChange = e => {
    setDURUM(e.target.value);
  };

  const handleDateChange = (event, type) => {
    var Deger = moment(event).format('YYYY-MM-DD');
    type === 1 ? setBaslangicTarihi(Deger) : setBitisTarihi(Deger);
  };

  const exportData = (data) => {
    return data;
  }

  const handleClickFull = () => {
    var RowSelectedFullParam = 0;
    if (RowSelectedFull) {
      RowSelectedFullParam = 0;
    } else {
      RowSelectedFullParam = 1;
    }
    let ScrapDataOld = [...ScrapData];
    ScrapDataOld.forEach(e => {
      e.RowSelected = RowSelectedFullParam;
    });
    setScrapData(ScrapDataOld);
    setRowSelectedFull(RowSelectedFullParam);
  }

  const GetMaterialImage = (event, materialCode) => {
    setOpenMaterialFile(true);
    setLoading(true);
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    setOpenMaterialFileTitle(materialCode + " Numaralı Malzeme Detayı");
    axios.get(`MaterialFile/${materialCode}`, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        setImageUrlMuadil(fileURL);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }
  const handleCloseMaterialFile = () => {
    setOpenMaterialFile(false);
  };


  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, Header } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
    return (
      <TableHead>
        <TableRow>
          {Header.map((headCell) => {
            if (headCell.id === "CHECKBOX") {
              return (
                <TableCell padding='none' align="center">
                  <Checkbox
                    onClick={event =>
                      handleClickFull()
                    }
                    color="primary"
                    checked={RowSelectedFull}
                    inputProps={{
                      'aria-labelledby': "ChcFull"
                    }}
                  />

                </TableCell>
              );
            } else {
              return (
                <TableCell
                  key={headCell.id}
                  align={'left'}
                  padding={headCell.disablePadding ? 'none' : 'default'}
                  sortDirection={orderBy === headCell.id ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    onClick={createSortHandler(headCell.id)}
                  >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                      <span className={classes.visuallyHidden}>
                        {''}
                      </span>
                    ) : null}
                  </TableSortLabel>
                </TableCell>
              );
            }

          })}
        </TableRow>
      </TableHead>
    );
  }
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  const headMalzemeZimmetCells = [
    { id: 'FIS_NO', numeric: true, disablePadding: true, label: 'FişNo' },
    { id: 'KUL_TEK_KODU', numeric: true, disablePadding: true, label: 'Teknisyen' },
    { id: 'DURUM', numeric: true, disablePadding: true, label: 'Durum' },
    { id: '#', numeric: true, disablePadding: true, label: 'Resim' },
    { id: 'MALZEME_STOK_NO', numeric: false, disablePadding: true, label: 'MalzemeStokNo' },
    { id: 'MALZEME', numeric: false, disablePadding: true, label: 'Malzeme' },
    { id: 'HURDA_DURUM', numeric: false, disablePadding: true, label: 'EskisiDurum' },
    { id: 'KRITIK', numeric: false, disablePadding: true, label: 'Kritik' },
    { id: 'ADET', numeric: true, disablePadding: true, label: 'Adet' },
    { id: 'ARAC_TAKIP_NO', numeric: false, disablePadding: true, label: 'AraçTakip' },
    { id: 'ISLEM_TARIHI', numeric: false, disablePadding: true, label: 'İşlemTarihi' },
    { id: 'ALINMA_DURUM', numeric: false, disablePadding: true, label: 'AlınmaDurum' },
    { id: 'SONUC_NOTU', numeric: false, disablePadding: true, label: 'SonucNotu' },
    { id: 'ESKISI_YOK_ACIKLAMA', numeric: false, disablePadding: true, label: 'EskisiYokAçıklama' },
    { id: 'SURUCU', numeric: false, disablePadding: true, label: 'Sürücü' },
    { id: 'PLAKA', numeric: false, disablePadding: true, label: 'Plaka' },
    { id: 'ARAC_TESLIM_TARIHI', numeric: false, disablePadding: true, label: 'AraçTeslimTarih' },

  ];

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };


  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Snackbar open={uyari} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyariTip}>
              {uyariAciklama || ''}
            </Alert>
          </Snackbar>
          <CardActions>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={2}>
                <FormControl variant="outlined" className={classes.fields}>
                  <Typography variant="h6" component="h2">
                    <Select
                      native
                      value={DURUM}
                      onChange={handleDurumChange}
                      fullWidth
                      labelId="durum_label"
                      inputProps={{
                        name: 'durum_select',
                        id: 'durum_select'
                      }}
                    >
                      <option value="" defaultValue>
                        {DURUM}
                      </option>
                      {DurumData.map(p => {
                        return (
                          <option
                            key={p.DURUM}
                            value={p.DURUM}
                          >
                            {p.ACIKLAMA}
                          </option>
                        );
                      })}
                    </Select>
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormControl variant="outlined" className={classes.fields}>
                  <Typography variant="h6" component="h2">
                    <Select
                      native
                      value={TeknisyenKodu}
                      onChange={handleteknisyenChange}
                      fullWidth
                      labelId="teknisyen_label"
                      inputProps={{
                        name: 'teknisyen_select',
                        id: 'teknisyen_select'
                      }}
                    >
                      <option value="" defaultValue>
                        {TeknisyenKodu}
                      </option>
                      {TeknisyenData.map(p => {
                        return (
                          <option
                            key={p.TEKNISYEN_KODU}
                            value={p.TEKNISYEN_KODU}
                          >
                            {p.KUL_TEK_KODU + '-' + p.ACIKLAMA}
                          </option>
                        );
                      })}
                    </Select>
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormControl variant="outlined" className={classes.fields}>
                  <Typography variant="h6" component="h2">
                    <ThemeProvider theme={materialTheme}>
                      <MuiPickersUtilsProvider
                        utils={DateFnsUtils}
                        locale={localeMap['tr']}
                      >
                        <KeyboardDatePicker
                          color="primary"
                          fullWidth
                          inputVariant="outlined"
                          invalidDateMessage={'Hatalı Tarih Formatı'}
                          format={'dd.MM.yyyy'}
                          variant="outlined"
                          value={baslangicTarihi}
                          onChange={e => handleDateChange(e, 1)}
                          KeyboardButtonProps={{
                            'aria-label': 'change date'
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </ThemeProvider>
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormControl variant="outlined" className={classes.fields}>
                  <Typography variant="h6" component="h2">
                    <ThemeProvider theme={materialTheme}>
                      <MuiPickersUtilsProvider
                        utils={DateFnsUtils}
                        locale={localeMap['tr']}>
                        <KeyboardDatePicker
                          color="primary"
                          fullWidth
                          inputVariant="outlined"
                          invalidDateMessage={'Hatalı Tarih Formatı'}
                          format={'dd.MM.yyyy'}
                          variant="outlined"
                          value={bitisTarihi}
                          onChange={e => handleDateChange(e, 2)}
                          KeyboardButtonProps={{
                            'aria-label': 'change date'
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </ThemeProvider>
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Button
                  variant="contained"
                  fullWidth
                  className={classes.button}
                  color="secondary"
                  endIcon={<SearchIcon></SearchIcon>}
                  onClick={onSorgula}
                >
                  Sorgula
                </Button>
              </Grid>
              <Grid item xs={12} sm={2}>
                <ExcelExport JsonData={exportData(ScrapData)} />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControl fullWidth className={classes.margin}>
                  <TextField
                    label="Arama Yapınız..."
                    value={ScrapSearch}
                    name={ScrapSearch}
                    className={clsx(classes.margin, classes.textField)}
                    onChange={event => { setFilter(event.target.value) }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      )
                    }}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </CardActions>
          <Divider />
          <CardContent>
            <TableContainer className={classes.container} component={Paper}>
              <Table size="small" stickyHeader>
                <EnhancedTableHead
                  classes={classes}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  Header={headMalzemeZimmetCells}
                />
                <TableBody>
                  {stableSort(ScrapData, getComparator(order, orderBy))
                    .map((row, index) => {
                      const labelId = `enhanced-table-checkbox-${index}`;
                      return (

                        <TableRow
                          hover
                          tabIndex={-1}
                          key={index}
                        >
                          <TableCell
                            align="left"
                            padding='none'
                          >
                            {
                              row.ESLENEN_FIS_NO === 0 ? <b style={{ color: 'blue' }}>{row.FIS_NO}</b> : <b style={{ color: 'red' }}>{row.FIS_NO}</b>
                            }
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                            title={row.TEKNISYEN}
                          >
                            {row.TEKNISYEN.substring(0, 10)}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                            title={row.DURUM}
                          >
                            {row.DURUM.substring(0, 10)}
                          </TableCell>
                          <TableCell
                            align="center"
                            padding='none'

                          >
                            <ImageSearchIcon
                              onClick={(event) => GetMaterialImage(event, row.MALZEME_STOK_NO.replace(/^0+/, ''))}
                              color="primary"
                            />
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'

                          >
                            {row.MALZEME_STOK_NO}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                            title={row.MALZEME}
                          >
                            {row.MALZEME.substring(0, 10)}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'

                          >
                            {row.HURDA_DURUM}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'

                          >
                            {row.KRITIK}
                          </TableCell>
                          <TableCell
                            align="center"
                            padding='none'

                          >
                            {row.ADET}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                            title={row.ARAC_TAKIP_NO}
                          >
                            {row.ARAC_TAKIP_NO.substring(0, 10)}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                          >
                            {row.ISLEM_TARIHI}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                          >
                            {row.ALINMA_DURUM}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                            title={row.SONUC_NOTU}
                          >
                            {row.SONUC_NOTU.substring(0, 20)}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                            title={row.ESKISI_YOK_ACIKLAMA}
                          >
                            {row.ESKISI_YOK_ACIKLAMA.substring(0, 10)}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                          >
                            {row.SURUCU}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                          >
                            {row.PLAKA}
                          </TableCell>
                          <TableCell
                            align="left"
                            padding='none'
                          >
                            {row.ARAC_TESLIM_TARIHI}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={ScrapData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </CardContent>
        </Card>
      </Container >
      <Dialog
        open={openMaterialFile}
        TransitionComponent={Transition}
        keepMounted
        fullWidth
        maxWidth='lg'
        onClose={handleCloseMaterialFile}      >
        <DialogTitle>
          {openMaterialFileTitle}
        </DialogTitle>
        <DialogContent>
          {Loading ? <LinearProgress
            status="loading"
          /> : <img style={{ width: '100%' }} alt='' src={ImageUrlMuadil} />}

        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMaterialFile} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

    </Page >
  );
}

export default ScrapReport;
